import { all, takeLatest } from 'redux-saga/effects';

import types from '@constants/action-types';
import {
  loginRequest,
  resendOtpRequest,
  verifyOtpRequest,
  setupTwoFactorAuthRequest,
} from '@store/auth/auth.reducer';

import { handleResendTwoFactorAuthCodeRequest } from './handleResendTwoFactorAuthCodeRequest';
import { handleVerifyTwoFactorAuthCodeRequest } from './handleVerifyTwoFactorAuthCodeRequest';
import { loginSaga } from './loginSaga';
import { resendOtpSaga } from './resendOtpSaga';
import { twoFactorAuthSetupSaga } from './twoFactorAuthSetupSaga';
import { verifyOtpSaga } from './verifyOtpSaga';

export default all([
  takeLatest(loginRequest.type, loginSaga),
  takeLatest(resendOtpRequest.type, resendOtpSaga),
  takeLatest(verifyOtpRequest.type, verifyOtpSaga),
  takeLatest(setupTwoFactorAuthRequest.type, twoFactorAuthSetupSaga),

  takeLatest(types.AUTH_TWO_FACTOR_AUTH_CODE_REQUEST, handleVerifyTwoFactorAuthCodeRequest),
  takeLatest(types.RESEND_TWO_FACTOR_AUTH_CODE_REQUEST, handleResendTwoFactorAuthCodeRequest),
]);
